import script from "./CellBgColorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CellBgColorModal.vue?vue&type=script&setup=true&lang=js"

import "./CellBgColorModal.vue?vue&type=style&index=0&id=3e9dd48b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e9dd48b"]])

export default __exports__